// extracted by mini-css-extract-plugin
export default {"CounterOfferStatus":"styles_CounterOfferStatus__H+Wbl","declined":"styles_declined__OUqRq","accepted":"styles_accepted__s-q-E"};